import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vModelText as _vModelText, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, normalizeClass as _normalizeClass, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bfafbe84"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg-white-50 p-4" }
const _hoisted_2 = { class: "row mx-4" }
const _hoisted_3 = { class: "row mb-5" }
const _hoisted_4 = { class: "w-max-content col-lg-2 col-form-label fs-9 fw-bold" }
const _hoisted_5 = { class: "row mb-5" }
const _hoisted_6 = { class: "col-lg-8 col-form-label fs-7" }
const _hoisted_7 = { class: "row mb-4" }
const _hoisted_8 = { class: "col-lg-2 col-form-label fs-7" }
const _hoisted_9 = { class: "col-lg-8 d-lg-flex align-items-center" }
const _hoisted_10 = { class: "input-group mb-2" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input-group-append" }, [
  /*#__PURE__*/_createElementVNode("label", {
    class: "input-group-text cursor-pointer h-100",
    type: "button",
    title: "Toggle",
    "data-toggle": ""
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "far fa-calendar-alt" })
  ])
], -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mx-lg-3 d-flex align-items-center pb-2" }, "～", -1))
const _hoisted_13 = { class: "input-group mb-2" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input-group-append" }, [
  /*#__PURE__*/_createElementVNode("label", {
    class: "input-group-text cursor-pointer h-100",
    type: "button",
    title: "Toggle",
    "data-toggle": ""
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "far fa-calendar-alt" })
  ])
], -1))
const _hoisted_15 = { class: "mb-4 fw-bold fs-16 bg-condition" }
const _hoisted_16 = { class: "mb-3 pb-4" }
const _hoisted_17 = { class: "row mb-4 border-bottom" }
const _hoisted_18 = { class: "col-lg-2 mb-2 fs-7" }
const _hoisted_19 = { class: "col-action-search d-flex flex-wrap" }
const _hoisted_20 = ["for"]
const _hoisted_21 = ["id", "value"]
const _hoisted_22 = {
  key: 0,
  class: "row align-items-center pb-4 mb-4 border-bottom"
}
const _hoisted_23 = { class: "col-lg-2 col-form-label fs-7" }
const _hoisted_24 = { class: "col-lg-2 row" }
const _hoisted_25 = { class: "col-lg-8" }
const _hoisted_26 = ["maxlength", "pattern"]
const _hoisted_27 = { class: "col-form-label col-lg-2 fs-7" }
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" ～ ")
const _hoisted_29 = { class: "col-lg-2 row" }
const _hoisted_30 = { class: "col-lg-8" }
const _hoisted_31 = ["maxlength", "pattern"]
const _hoisted_32 = { class: "col-form-label col-lg-2 fs-7" }
const _hoisted_33 = {
  key: 1,
  class: "row align-items-center"
}
const _hoisted_34 = { class: "col-lg-2 col-form-label fs-7" }
const _hoisted_35 = { class: "col-lg-8 row" }
const _hoisted_36 = { class: "col-lg-8" }
const _hoisted_37 = {
  class: "form-check-label fs-7",
  for: "enable-condition1_not"
}
const _hoisted_38 = { class: "mb-4 fs-16 bg-condition" }
const _hoisted_39 = { class: "row" }
const _hoisted_40 = { class: "col-lg-2 fw-bold" }
const _hoisted_41 = { class: "col-lg-10" }
const _hoisted_42 = {
  class: "form-check-label fs-7",
  for: "enable-search-condition-two"
}
const _hoisted_43 = { class: "mb-3" }
const _hoisted_44 = { class: "row mb-4 border-bottom" }
const _hoisted_45 = { class: "col-lg-2 mb-2 fs-7" }
const _hoisted_46 = { class: "col-action-search d-flex flex-wrap" }
const _hoisted_47 = ["for"]
const _hoisted_48 = ["id", "value"]
const _hoisted_49 = {
  key: 0,
  class: "row align-items-center pb-4 mb-4 border-bottom"
}
const _hoisted_50 = { class: "col-lg-2 col-form-label fs-7" }
const _hoisted_51 = { class: "col-lg-2 row" }
const _hoisted_52 = { class: "col-lg-8" }
const _hoisted_53 = ["maxlength", "pattern"]
const _hoisted_54 = { class: "col-form-label col-lg-2 fs-7" }
const _hoisted_55 = /*#__PURE__*/_createTextVNode(" ～ ")
const _hoisted_56 = { class: "col-lg-2 row" }
const _hoisted_57 = { class: "col-lg-8" }
const _hoisted_58 = ["maxlength", "pattern"]
const _hoisted_59 = { class: "col-form-label col-lg-2 fs-7" }
const _hoisted_60 = {
  key: 1,
  class: "row align-items-center"
}
const _hoisted_61 = { class: "col-lg-2 col-form-label fs-7" }
const _hoisted_62 = { class: "col-lg-8 row" }
const _hoisted_63 = { class: "col-lg-8" }
const _hoisted_64 = {
  class: "form-check-label fs-7",
  for: "enable-condition2_not"
}

import { computed, onMounted, ref, watch } from 'vue'
import flatPickr from 'vue-flatpickr-component'
import { Japanese } from 'flatpickr/dist/l10n/ja.js'
import { translate } from '@/languages/i18n'
import { useStore } from 'vuex'
import { CONVERSATIONS_STORE } from '@/store/constants'
import { MAX_LENGTH_INTEGER } from '@/constants/number'
import { REGEX_NUMERIC, REGEX_NUMERIC_INTEGER } from '@/constants/regex'
import dayjs from 'dayjs'


export default /*#__PURE__*/_defineComponent({
  props: {
  resetDataDetail: {
    type: Boolean,
  },
  tabAction: {
    type: Boolean,
  },
  filterForAlumni: {
    type: Boolean,
    default: false,
  },
},
  emits: ['formDetail'],
  setup(__props, { emit }) {

const props = __props

const dataSearchDetail = computed(() => store.getters[CONVERSATIONS_STORE.GETTERS.GET_DATA_SEARCH_DETAIL])

const configDateSearch = {
  disableMobile: true,
  locale: Japanese,
  wrap: true,
  dateFormat: 'Y/m/d',
  minDate: '2022/01/01',
  // 2022/11/09 TienNV Fix bug performance  UAT#5118 (Ph2-R20221111)
  maxDate: dayjs(new Date()).add(-1, 'day').format('YYYY/MM/DD'),
}



const store = useStore()

onMounted(() => {
  if (Object.keys(dataSearchDetail.value.action).length > 0) {
    ActionData.value = dataSearchDetail.value.action
  }
})

const listActions = [
  {
    value: 'community_participation',
    title: 'コミュニティ参加',
  },
  {
    value: 'last_login',
    title: '最終ログイン',
  },
  {
    value: 'like',
    title: 'いいね',
  },
  {
    value: 'comment',
    title: 'コメント',
  },
  {
    value: 'invite',
    title: '招待',
  },
  {
    value: 'interest',
    title: '興味あり',
  },
  {
    value: 'add_post_article',
    title: '記事投稿',
  },
  {
    value: 'add_post_recruitment',
    title: '募集投稿',
  },
]
const ActionData = ref({
  start_period: '',
  end_period: '',
  action_search: 'community_participation',
  action_search1: 'community_participation',
  action_count_from: '',
  action_count_from1: '',
  action_count_to: '',
  action_count_to1: '',
  include_search_action1: false,
  condition1_not: false,
  condition2_not: false,
})

watch(
  () => props.resetDataDetail,
  () => {
    if (props.resetDataDetail) {
      ActionData.value.start_period = ''
      ActionData.value.end_period = ''
      ActionData.value.action_search = 'community_participation'
      ActionData.value.action_search1 = 'community_participation'
      ActionData.value.action_count_from = ''
      ActionData.value.action_count_from1 = ''
      ActionData.value.action_count_to = ''
      ActionData.value.action_count_to1 = ''
      ActionData.value.include_search_action1 = false
      ActionData.value.condition1_not = false
      ActionData.value.condition2_not = false
      store.dispatch(CONVERSATIONS_STORE.ACTIONS.SET_DATA_SEARCH_DETAIL, { typeData: 'action', data: ActionData.value })
    }
  }
)

watch(
  () => props.tabAction,
  () => {
    if (props.tabAction) {
      // let dataSearch = {}
      // if (ActionData.value.action_search === ActionData.value.action_search1) {
      //   Object.assign(dataSearch, {
      //     start_period: ActionData.value.start_period,
      //     end_period: ActionData.value.end_period,
      //     action_search: ActionData.value.action_search,
      //     action_count_from: handleActionCountFrom(),
      //     action_count_to: handleActionCountTo(),
      //   })
      // } else {
      //   dataSearch = ActionData.value
      // }
      // emit('formDetail', dataSearch)

      // 2022/10/24 CW-TrungNT Fix UAT#4533: OE10 (Ph2-R20221028)
      objChanged()
    }
  }
)

const objChanged = () => {
  // 2022/10/24 CW-TrungNT Fix UAT#4533: OE10 (Ph2-R20221028)
  let dataSearch = {}
  store.dispatch(CONVERSATIONS_STORE.ACTIONS.SET_DATA_SEARCH_DETAIL, { typeData: 'action', data: ActionData.value })
  if (ActionData.value.include_search_action1) {
    dataSearch = ActionData.value
  } else {
    Object.assign(dataSearch, {
      start_period: ActionData.value.start_period,
      end_period: ActionData.value.end_period,
      action_search: ActionData.value.action_search,
      action_count_from: ActionData.value.action_count_from,
      action_count_to: ActionData.value.action_count_to,
      condition1_not: ActionData.value.condition1_not,
      condition2_not: ActionData.value.condition2_not,
    })
  }
  emit('formDetail', dataSearch)
}

// 2022/10/12 PhucNV Fix bug input only numberic UAT#4429: OE10,OE12,OE56(Ph2-R20221014)
const onlyNumberKey = (event) => {
  let char = String.fromCharCode(event.keyCode)
  if (!REGEX_NUMERIC.test(char)) {
    event.preventDefault()
  }
}

const onlyPasteNumber = (event) => {
  let copiedText = event.clipboardData.getData('text')
  if (!REGEX_NUMERIC.test(copiedText)) {
    event.preventDefault()
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _cache[19] || (_cache[19] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitAction && _ctx.submitAction(...args)), ["prevent"])),
    class: "row align-items-center"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("label", _hoisted_4, _toDisplayString(_unref(translate)(`OE10actionSearch`)), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(translate)('OE10titleTab3')), 1)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(translate)('OE10period')), 1),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_unref(flatPickr), {
                  modelValue: ActionData.value.start_period,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((ActionData.value.start_period) = $event)),
                  placeholder: "2000/01/01",
                  config: configDateSearch,
                  class: "form-control bg-white",
                  onChange: objChanged
                }, null, 8, ["modelValue"]),
                _hoisted_11
              ])
            ]),
            _hoisted_12,
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_unref(flatPickr), {
                  modelValue: ActionData.value.end_period,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((ActionData.value.end_period) = $event)),
                  placeholder: "2000/01/01",
                  config: configDateSearch,
                  class: "form-control bg-white",
                  onChange: objChanged
                }, null, 8, ["modelValue"]),
                _hoisted_14
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_15, _toDisplayString(_unref(translate)('OE10condition1')), 1),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, _toDisplayString(_unref(translate)('OE10action')), 1),
            _createElementVNode("div", _hoisted_19, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(listActions, (action, index) => {
                return _createElementVNode("div", {
                  class: "form-check me-5 mb-4 fs-7",
                  key: index
                }, [
                  _createElementVNode("label", {
                    class: "form-check-label",
                    for: action.value
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input",
                      type: "radio",
                      name: "action",
                      id: action.value,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((ActionData.value.action_search) = $event)),
                      value: action.value,
                      onChange: objChanged
                    }, null, 40, _hoisted_21), [
                      [_vModelRadio, ActionData.value.action_search]
                    ]),
                    _createTextVNode(" " + _toDisplayString(action.title), 1)
                  ], 8, _hoisted_20)
                ])
              }), 64))
            ])
          ]),
          (!['community_participation', 'last_login'].includes(ActionData.value.action_search))
            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, _toDisplayString(_unref(translate)('OE10numberOfTime')), 1),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      maxlength: _unref(MAX_LENGTH_INTEGER),
                      pattern: _unref(REGEX_NUMERIC_INTEGER),
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((ActionData.value.action_count_from) = $event)),
                      class: "form-control fs-7",
                      onChange: objChanged,
                      onKeypress: _cache[4] || (_cache[4] = ($event: any) => (onlyNumberKey($event))),
                      onPaste: _cache[5] || (_cache[5] = ($event: any) => (onlyPasteNumber($event)))
                    }, null, 40, _hoisted_26), [
                      [
                        _vModelText,
                        ActionData.value.action_count_from,
                        void 0,
                        { trim: true }
                      ]
                    ])
                  ]),
                  _createElementVNode("label", _hoisted_27, _toDisplayString(_unref(translate)('times')), 1)
                ]),
                _hoisted_28,
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("div", _hoisted_30, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      maxlength: _unref(MAX_LENGTH_INTEGER),
                      pattern: _unref(REGEX_NUMERIC_INTEGER),
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((ActionData.value.action_count_to) = $event)),
                      class: "form-control fs-7",
                      onChange: objChanged,
                      onKeypress: _cache[7] || (_cache[7] = ($event: any) => (onlyNumberKey($event))),
                      onPaste: _cache[8] || (_cache[8] = ($event: any) => (onlyPasteNumber($event)))
                    }, null, 40, _hoisted_31), [
                      [
                        _vModelText,
                        ActionData.value.action_count_to,
                        void 0,
                        { trim: true }
                      ]
                    ])
                  ]),
                  _createElementVNode("label", _hoisted_32, _toDisplayString(_unref(translate)('times')), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          (__props.filterForAlumni)
            ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                _createElementVNode("div", _hoisted_34, _toDisplayString(_unref(translate)('OE10excludeSelection')), 1),
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("label", _hoisted_37, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((ActionData.value.condition1_not) = $event)),
                        class: "form-check-input me-2",
                        type: "checkbox",
                        name: "enable-condition1_not",
                        id: "enable-condition1_not",
                        onChange: objChanged
                      }, null, 544), [
                        [_vModelCheckbox, ActionData.value.condition1_not]
                      ]),
                      _createTextVNode(" " + _toDisplayString(_unref(translate)('OE10excludeThisUser')), 1)
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_38, [
          _createElementVNode("div", _hoisted_39, [
            _createElementVNode("span", _hoisted_40, _toDisplayString(_unref(translate)('OE10condition2')), 1),
            _createElementVNode("div", _hoisted_41, [
              _createElementVNode("label", _hoisted_42, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((ActionData.value.include_search_action1) = $event)),
                  class: "form-check-input me-2",
                  type: "checkbox",
                  name: "enable-search-condition-two",
                  id: "enable-search-condition-two",
                  onChange: objChanged
                }, null, 544), [
                  [_vModelCheckbox, ActionData.value.include_search_action1]
                ]),
                _createTextVNode(" " + _toDisplayString(_unref(translate)('OE10includeSearchCriteria')), 1)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_43, [
          _createElementVNode("div", _hoisted_44, [
            _createElementVNode("div", _hoisted_45, _toDisplayString(_unref(translate)('OE10action')), 1),
            _createElementVNode("div", _hoisted_46, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(listActions, (action, index) => {
                return _createElementVNode("div", {
                  class: "form-check me-5 mb-4 fs-7",
                  key: index
                }, [
                  _createElementVNode("label", {
                    class: "form-check-label",
                    for: action.value + '_sd'
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input",
                      type: "radio",
                      name: "action_sd",
                      id: action.value + '_sd',
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((ActionData.value.action_search1) = $event)),
                      value: action.value,
                      onChange: objChanged
                    }, null, 40, _hoisted_48), [
                      [_vModelRadio, ActionData.value.action_search1]
                    ]),
                    _createTextVNode(" " + _toDisplayString(action.title), 1)
                  ], 8, _hoisted_47)
                ])
              }), 64))
            ])
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(['align-items-center', __props.filterForAlumni ? ' border-bottom pb-4' : ''])
          }, [
            (!['community_participation', 'last_login'].includes(ActionData.value.action_search1))
              ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                  _createElementVNode("div", _hoisted_50, _toDisplayString(_unref(translate)('OE10numberOfTime')), 1),
                  _createElementVNode("div", _hoisted_51, [
                    _createElementVNode("div", _hoisted_52, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        maxlength: _unref(MAX_LENGTH_INTEGER),
                        pattern: _unref(REGEX_NUMERIC_INTEGER),
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((ActionData.value.action_count_from1) = $event)),
                        class: "form-control fs-7",
                        onChange: objChanged,
                        onKeypress: _cache[13] || (_cache[13] = ($event: any) => (onlyNumberKey($event))),
                        onPaste: _cache[14] || (_cache[14] = ($event: any) => (onlyPasteNumber($event)))
                      }, null, 40, _hoisted_53), [
                        [
                          _vModelText,
                          ActionData.value.action_count_from1,
                          void 0,
                          { trim: true }
                        ]
                      ])
                    ]),
                    _createElementVNode("label", _hoisted_54, _toDisplayString(_unref(translate)('times')), 1)
                  ]),
                  _hoisted_55,
                  _createElementVNode("div", _hoisted_56, [
                    _createElementVNode("div", _hoisted_57, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        maxlength: _unref(MAX_LENGTH_INTEGER),
                        pattern: _unref(REGEX_NUMERIC_INTEGER),
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((ActionData.value.action_count_to1) = $event)),
                        class: "form-control fs-7",
                        onChange: objChanged,
                        onKeypress: _cache[16] || (_cache[16] = ($event: any) => (onlyNumberKey($event))),
                        onPaste: _cache[17] || (_cache[17] = ($event: any) => (onlyPasteNumber($event)))
                      }, null, 40, _hoisted_58), [
                        [
                          _vModelText,
                          ActionData.value.action_count_to1,
                          void 0,
                          { trim: true }
                        ]
                      ])
                    ]),
                    _createElementVNode("label", _hoisted_59, _toDisplayString(_unref(translate)('times')), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            (__props.filterForAlumni)
              ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                  _createElementVNode("div", _hoisted_61, _toDisplayString(_unref(translate)('OE10excludeSelection')), 1),
                  _createElementVNode("div", _hoisted_62, [
                    _createElementVNode("div", _hoisted_63, [
                      _createElementVNode("label", _hoisted_64, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((ActionData.value.condition2_not) = $event)),
                          class: "form-check-input me-2",
                          type: "checkbox",
                          name: "enable-condition2_not",
                          id: "enable-condition2_not",
                          onChange: objChanged
                        }, null, 544), [
                          [_vModelCheckbox, ActionData.value.condition2_not]
                        ]),
                        _createTextVNode(" " + _toDisplayString(_unref(translate)('OE10excludeThisUser')), 1)
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ], 2)
        ])
      ])
    ])
  ], 32))
}
}

})